export const BI_EVENTS_IDS = {
  PANEL_LOADED: 301,
  PANEL_CLOSED: 302,
  TAB_LOAD: 303,
  TAB_CLICK: 304,
  ACTION_CLICK: 305,
  SETUP_ACTION_DONE: 306,
  SETUP_COMPLETED: 307,
  PANEL_CLOSE_CLICK: 308,
  PANEL_HELP_CLICK: 309,
};

export const PLATFORM_HOST_INTEGRATION_BI_SRC = 164;
export const PLATFORM_BI_ENDPOINT = 'editor-platform';

export const BI_PARAMS = {
  SECTIONS: {
    THREE_DOT_MENU: 'three_dots_menu',
    SETUP: 'setup',
    UPGRADE: 'upgrade',
    MANAGE: 'manage',
    RECOMMENDED_TOOLS: 'recommended-tools',
    FIND_APPS: 'find-apps',
  },
  TARGET_CTA: {
    BUTTON_CLICKED: 'button_clicked',
  },
  ACTION_ID: {
    UPGRADE: 'upgrade-app-action',
    THREE_DOT_MENU: 'three_dots_menu',
    RECOMMENDED_TOOLS: 'recommended-tools-',
  },
};
